import React, { Component } from "react";
import { Card, Tab, Tabs } from "react-bootstrap";

class Kishu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      json: this.props.json ? this.props.json : "",
      gender: this.props.gender ? this.props.gender : "m",
      loadImg: "/images/loader.webp",
      errorImg: "/images/" + this.props.gender[0] + ".jpg",
      key: "attr",
      loading: true,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.json !== this.props.json)
      this.setState({ json: this.props.json, loading: true });
    //console.log(this.state.json);
  }

  render() {
    var kishu = this.props.json;

    if (kishu === "") {
      return <div className="card p-0 mx-1">Invalid Kishu</div>;
    } else {
      let renderAttributes = "";
      try {
        renderAttributes = kishu.attributes.map((attribute, i) => {
          return (
            <div className="row" key={i}>
              <div className="col text-capitalize fw-bold">
                {attribute.trait_type}
              </div>
              <div className="col ">{attribute.value}</div>
            </div>
          );
        });
      } catch (error) {
        renderAttributes = (
          <div className="" style={{ fontSize: "0.8rem" }}>
            I saved you chodes 8=D
            <br /> - Inthernar
          </div>
        );
      }

      let renderTraits = "";
      try {
        renderTraits = kishu.traits.map((trait, i) => {
          return (
            <p key={i} className="">
              {trait.name} ({trait.category})
              <br />
              Rank: {trait.rank} Dom: {trait.dominance} <br />
              P: {trait.power} Sp: {trait.speed}
              <br />
              W: {trait.weight} Sm: {trait.smarts}
            </p>
          );
        });
      } catch (error) {
        renderTraits = (
          <div className="" style={{ fontSize: "0.8rem" }}>
            I saved you chodes 8=D
            <br /> - Inthernar
          </div>
        );
      }

      let renderStats = "";
      try {
        renderStats = kishu.stats.map((stats, i) => {
          return (
            <div key={i++} className="">
              {stats.name}: {stats.value}
            </div>
          );
        });
      } catch (error) {
        renderStats = (
          <div className="" style={{ fontSize: "0.8rem" }}>
            I saved you chodes 8=D
            <br /> - Inthernar
          </div>
        );
      }

      return (
        <div>
          <Card className="p-0 mx-1">
            <Card.Img
              variant="top"
              src={
                this.state.loading
                  ? this.state.loadImg
                  : kishu.image.indexOf("ipfs") >= 0
                  ? kishu.image.replace(
                      "ipfs://",
                      "https://gateway.pinata.cloud/ipfs/"
                    )
                  : kishu.image
              }
              onError={({ currentTarget }) => {
                console.log("errImg: ", currentTarget.src);
                currentTarget.src = this.state.errorImg;
                this.setState({ loading: false });
                currentTarget.onerror = null; // prevents looping
              }}
              onLoad={() => this.setState({ loading: false })}
              alt={kishu.description}
              title={kishu.description}
            />
            <Card.ImgOverlay className="">
              <Card.Text
                className="fw-bold text-danger bg-edition float-end"
                style={{
                  width: "58px",
                  height: "54px",
                  marginTop: "-10px",
                  paddingTop: "8px",
                }}
              >
                {kishu.edition}
              </Card.Text>
            </Card.ImgOverlay>
            <Card className="card-body">
              <Tabs
                activeKey={this.state.key}
                onSelect={(k) => this.setState({ key: k })}
                id={`${this.state.gender}TabController`}
                className="mb-3"
              >
                <Tab eventKey="stats" title="Stats">
                  <h5 className="card-title">{kishu.name}</h5>
                  <Card.Text className="card-text">
                    {kishu.description}
                  </Card.Text>
                  <Card.Text className="card-text">
                    Born: {this.getKishuDate(kishu.date)}
                  </Card.Text>
                  {renderStats}
                </Tab>
                <Tab eventKey="traits" title="Traits">
                  {renderTraits}
                </Tab>
                <Tab eventKey="attr" title="Attr">
                  {renderAttributes}
                </Tab>
              </Tabs>
            </Card>
            <div className="card-footer font-footer">{kishu.dna}</div>
          </Card>
        </div>
      );
    }
  }

  getKishuDate(theDate) {
    const timestamp = new Date(theDate);
    return timestamp.toDateString();
  }
}
export default Kishu;
